"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _StatusIconTooltip = _interopRequireDefault(require("./StatusIconTooltip"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * Checks if a question topic is answered based on best answer flag or features
 */
var isQuestionAnswered = function isQuestionAnswered(topic) {
  var _topic$features, _topic$features$;

  return Boolean(topic.hasBestAnswer || (topic === null || topic === void 0 ? void 0 : (_topic$features = topic.features) === null || _topic$features === void 0 ? void 0 : (_topic$features$ = _topic$features[0]) === null || _topic$features$ === void 0 ? void 0 : _topic$features$.id) === 'isAnswered');
};
/**
 * Checks if a topic is an idea based on contentType
 */


var isIdeaTopic = function isIdeaTopic(topic) {
  return topic.contentType === 'idea';
};
/**
 * Gets the tooltip label based on topic type and status
 */


var getTooltipLabel = function getTooltipLabel(topic) {
  var _topic$ideationStatus;

  if (isIdeaTopic(topic) && (_topic$ideationStatus = topic.ideationStatus) !== null && _topic$ideationStatus !== void 0 && _topic$ideationStatus.name) {
    return topic.ideationStatus.name;
  }

  return null;
};
/**
 * A component that displays an appropriate tooltip icon for a topic
 * based on its type (ideation/question) and status
 */


var TopicTooltip = function TopicTooltip(_ref) {
  var topic = _ref.topic;
  var isIdea = isIdeaTopic(topic); // Return null for topics that are not ideas and not questions

  if (!isIdea && topic.contentType !== 'question') {
    return null;
  } // Determine if question is answered (only relevant for question content type)


  var answered = topic.contentType === 'question' && isQuestionAnswered(topic); // Get the tooltip label

  var label = getTooltipLabel(topic); // For questions, use phrase component to get the appropriate label

  var phraseKey = answered ? 'beantwoord' : 'vraag';
  return (0, _preact.h)(_phrase.default, {
    p: phraseKey,
    renderAsText: true
  }, function (labelPhrase) {
    var _topic$ideationStatus2;

    // Use labelPhrase for questions, otherwise use the ideation label
    var tooltipText = topic.type === 'post' ? labelPhrase : label;
    return (0, _preact.h)(_StatusIconTooltip.default, {
      iconClassName: (0, _classnames.default)('icon--auto-width', {
        'icon--idea': isIdea,
        'icon--thread-solved': topic.contentType === 'question' && answered,
        'icon--question-circle': topic.contentType === 'question' && !answered
      }),
      tooltipText: tooltipText,
      iconStyle: isIdea && (_topic$ideationStatus2 = topic.ideationStatus) !== null && _topic$ideationStatus2 !== void 0 && _topic$ideationStatus2.bgColor ? {
        color: topic.ideationStatus.bgColor
      } : {}
    });
  });
};

var _default = TopicTooltip;
exports.default = _default;